import { render, staticRenderFns } from "./TotalItemComponent.vue?vue&type=template&id=f2a5a874&scoped=true&lang=pug"
import script from "./TotalItemComponent.vue?vue&type=script&lang=ts"
export * from "./TotalItemComponent.vue?vue&type=script&lang=ts"
import style0 from "./TotalItemComponent.vue?vue&type=style&index=0&id=f2a5a874&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a5a874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2a5a874')) {
      api.createRecord('f2a5a874', component.options)
    } else {
      api.reload('f2a5a874', component.options)
    }
    module.hot.accept("./TotalItemComponent.vue?vue&type=template&id=f2a5a874&scoped=true&lang=pug", function () {
      api.rerender('f2a5a874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Totals/TotalItemComponent.vue"
export default component.exports